import { IVec3 } from "@base/math/Vec3";
import { PartialRecord, TupleToUnion } from "@base/util/TypeUtil";
import { IProductData } from "@biz/definitions/ProductDefinitions";
import { Auto } from "@biz/definitions/SunSailDefinitions";
import { IClothItemData } from "@biz/logic/ClothData";
import { ISail2dProductBaseForm } from "@biz/models/Sail2dDefinitions";

// export type CurtainSystemDescriptor = { id: string } | { id: string; trackIndex: number } | { id: string; trackIndex: number; cornerIndex: number } | { id: string; trackIndex: number; clothIndex: number };
// export type CurtainDescriptor = Omit<CurtainSystemDescriptor, "id">;
export type CurtainClothDescriptor = { trackIndex: number; clothIndex: number }

export type CurtainConfectionType = "flap" // Vorhangband
  | "grommet" // PE Band und Öse;
  | "pe" // PE Band
  | "special" // SonderKonfektion

export type CurtainConfectionBottomType = "lead";
export type CurtainSuspensionType = "plasticRoll" | "metalRoll" | "glider" | "carabiner" | "carabinerPulley" | "none";
export type CurtainClothAlign = "left" | "right" | "center";

export const tieBackTypes = ["grommet", "touchFastener"] as const;
export type CurtainTieBackType = TupleToUnion<typeof tieBackTypes>;

export const DEFAULT_MAX_FIX_DIST = 0.2;

export type CurtainClothShape = "rect" | "slopingLeft" | "slopingRight";
export interface ICurtainClothAuto extends IClothItemData {
  height: number;
  width: number;
  additionFactor: Auto<number>;
  confectionType: CurtainConfectionType;
  confectionBottomType: CurtainConfectionBottomType;
  suspensionType: CurtainSuspensionType;
  tieBackType?: CurtainTieBackType;
  maxFixDist: number;
}

export interface ICurtainCloth extends Partial<ICurtainClothAuto> {
  align?: CurtainClothAlign;
  anchorPoint?: number;
  offset?: number;
  tieBackCount: number;
  tieBackLength: Auto<number>;

  shape: CurtainClothShape;
  // sloping
  height2?: number;
  width2?: number;
}

export interface ICurtain2dCloth extends Partial<ICurtainClothAuto> {
  count: number;
  tieBackCount: number;
  tieBackLength: Auto<number>;


  shape: CurtainClothShape;
  // sloping
  height2?: number;
  width2?: number;
}


export type TrackJointType = "stop" | "miter" | "arc";
export type CurtainCornerArticleSlots = "startTerminal" | "endTerminal" | "ropeMount" | "startTensioner" | "endTensioner" | "startNotch" | "endNotch";
export interface ICurtainTrackCorner {
  jointType: TrackJointType;
  angle: number;
  length: number;
  articleSlots?: PartialRecord<CurtainCornerArticleSlots, string>,
  // additionalRopeLength?: number;
}
export interface ICurtainTrackCornerRef {
  corner: ICurtainTrackCorner;
  index: number;
}
export interface ICurtainTrack {
  pos: IVec3;
  angle: number;
  corners: ICurtainTrackCorner[];
  clothes: ICurtainCloth[];
}

export type CurtainType = "guide" | "rope" | "clothOnly";
export type SideType = "start" | "end";
export interface ICurtainData extends IProductData {
  itemType: "curtain";
  curtainType: CurtainType;
  pos: IVec3;
  rotationY: number;
  tracks: ICurtainTrack[];
  clothGlobal: ICurtainClothAuto;
}
export interface ICurtain2dTrack {
  length: number;
  count: number;
  startNotch?: boolean;
  endNotch?: boolean;
  startAngle?: number;
  endAngle?: number;
}

export interface ICurtain2dRope {
  length: number;
  count: number;
  startTerminal?: boolean;
  endTerminal?: boolean;
}

export interface ITieBackExtra {
  length: number;
  count: number;
}

export interface ICurtain2dForm extends ISail2dProductBaseForm {
  productType: "curtain2d";
  curtainType: CurtainType;
  tracks: ICurtain2dTrack[];
  ropes: ICurtain2dRope[];
  clothGlobal: ICurtainClothAuto;
  clothes: ICurtain2dCloth[];
  suspensionCount: Auto<number>;
  extraTieBacks: ITieBackExtra[];
}

export class Curtain2d {
  static createTrack(): ICurtain2dTrack {
    return {
      length: 2,
      count: 1
    }
  }

  static createRope(): ICurtain2dRope {
    return {
      length: 2,
      count: 1
    }
  }

  static createCloth(shape: CurtainClothShape): ICurtain2dCloth {
    const width = 2;
    const h1 = 2.5;
    const h2 = 2.0;
    const ret: ICurtain2dCloth = {
      shape,
      count: 1,
      width: width,
      height: h1,
      tieBackCount: 1,
      tieBackLength: "auto",
    }
    if (shape === "slopingLeft") {
      ret.width2 = 2.1;
      ret.height = h1;
      ret.height2 = h2;
    } else if (shape === "slopingRight") {
      ret.width2 = 2.1;
      ret.height = h2
      ret.height2 = h1;
    }

    return ret;
  }
}
